import React from 'react';
export const SubtractPolygon = () => {
  return <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" transform="matrix(-1, 0, 0, -1, 0, 0)">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        {' '}
        <path d="M16 3.5V3C16 2.44772 15.5523 2 15 2H14M10 2H8M4 2H3C2.44772 2 2 2.44772 2 3V4M2 8V10M2 14V15C2 15.5523 2.44772 16 3 16H3.5M10 16H8V21C8 21.5523 8.44772 22 9 22H21C21.5523 22 22 21.5523 22 21V9C22 8.44772 21.5523 8 21 8H16V10M14 16H15C15.5523 16 16 15.5523 16 15V14" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>{' '}
      </g>
    </svg>;
};